import './index.scss';
import Crumb from './crumb';
import PropTypes from 'prop-types';
import React from 'react';

const BreadCrumbs = props => (

    <section className="bread-crumbs">

        {props.crumbs.map( ( item, i ) => (
            <Crumb key={`crumb-${i}`} link={item.link} text={item.text} last={props.crumbs.length === i + 1} />
        ) )}

    </section>

);

BreadCrumbs.displayName = 'BreadCrumbs';
BreadCrumbs.propTypes = {
    crumbs: PropTypes.array.isRequired
};

export default BreadCrumbs;
